module.exports = __webpack_public_path__ + "static/img/ourAppBtn2.e9119346.png";